<template>
  <div class="sleep-improve">
    <div class="container">
      <!-- Title -->
      <h1 class="title">How can I improve my sleep?</h1>

      <!-- Top 2 cards -->
      <div class="grid-2">
        <div class="card">
          <div class="card-top">
            <div class="card-title">Bed Time Variability</div>
          </div>

          <div style="display: flex;align-items: center;justify-content: space-between;">
                <div class="card-value">15m</div>
                <div class="icon">
                    <!-- simple bed icon -->
                    <IconSunSet :size="'1.3rem'"></IconSunSet>
                </div>
          </div>
        </div>

        <div class="card">
          <div class="card-top">
            <div class="card-title">Wake Time Variability</div>
          </div>

          <div style="display: flex;align-items: center;justify-content: space-between;">
                <div class="card-value">20m</div>
                <div class="icon">
                    <IconSunRise :size="'1.3rem'"></IconSunRise>
                </div>
          </div>
        </div>
      </div>

      <!-- Body text -->
      <section class="section">
        <h2 class="sub-title">Improve your sleep consistency</h2>
        <p class="text-sm accordion-body text-lighter opacity-8">
          Your body has a 24-hour internal clock called your circadian rhythm.
          Going to bed and waking up at similar times each day helps regulate it
          and improves the quality of your sleep.
        </p>

        <h2 class="sub-title">Improve your sleep consistency</h2>
        <p class="text-sm accordion-body text-lighter opacity-8">
          Exercise during the day, avoid using electronics with blue light
          before bed and sleep in a quiet, dark and cool environment.
        </p>
      </section>

      <!-- OSD -->
      <h2 class="sub-title big-gap">What is Optimal Sleep Duration?</h2>

      <div class="grid-3">
        <div class="mini-card">
          <div class="mini-value">8:10</div>
          <div class="mini-label">OSD</div>
        </div>

        <div class="mini-card">
          <div class="mini-value">+0:0</div>
          <div class="mini-label">Strain</div>
        </div>

        <div class="mini-card">
          <div class="mini-value">+0:35</div>
          <div class="mini-label">Sleep Debt</div>
        </div>
      </div>

      <p class="text-sm accordion-body text-lighter opacity-8">
        Optimal Sleep Duration (OSD) calculates the minimum amount of sleep you
        need each night based on your sleep data. By consistently getting
        sufficient sleep, your OSD becomes more accurate over time. While most
        adults typically require 6 to 10 hours of sleep to feel rested, your
        optimal sleep duration may vary.
      </p>
    </div>
  </div>
</template>

<script>
import IconSunSet from "@/shared/Controls/Icons/IconSunSet.vue";
import IconSunRise from "@/shared/Controls/Icons/IconSunRise.vue";

export default {
  name: "SleepImproveScreen",
  components: {
    IconSunSet,
    IconSunRise,
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.sleep-improve {
  margin-top: 1rem;
  width: 100%;
}

.container {
  width: 98%;
  padding: 1rem;
}

.title {
  font-size: 28px;
  font-weight: 800;
  letter-spacing: 0.2px;
  margin: 6px 0 18px;
}

.grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-bottom: 16px;
}

.card {
  position: relative;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.05));
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  padding: 14px 14px 12px;
  min-height: 118px;
}

.card-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
}

.card-title {
  font-size: 14px;
  line-height: 1.15;
  color: rgba(255, 255, 255, 0.82);
  letter-spacing: 0.2px;
}

.icon {
  width: 28px;
  height: 28px;
  color: rgba(255, 255, 255, 0.38);
  display: grid;
  place-items: center;
}

.icon svg {
  width: 100%;
  height: 100%;
}

.card-value {
  margin-top: 10px;
  font-size: 26px;
  font-weight: 800;
  letter-spacing: 0.3px;
}

.card-bottom {
  position: absolute;
  right: 12px;
  bottom: 10px;
}

.badge {
  width: 26px;
  height: 26px;
  display: grid;
  place-items: center;
  color: rgba(255, 255, 255, 0.45);
}

.badge svg {
  width: 22px;
  height: 22px;
}

.section {
  margin-top: 10px;
}

.sub-title {
  font-size: 1rem;
  font-weight: bold;
  color: white;
}

.h2 {
  font-size: 16px;
  font-weight: 800;
  margin: 16px 0 8px;
  letter-spacing: 0.2px;
}

.p {
  font-size: 13px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.75);
  margin: 0 0 12px;
  max-width: 680px;
}

.big-gap {
  margin-top: 22px;
}

.grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin: 12px 0 14px;
}

.mini-card {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.05));
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  padding: 14px 10px 12px;
  text-align: center;
  min-height: 74px;
}

.mini-value {
  font-size: 22px;
  font-weight: 900;
  letter-spacing: 0.3px;
}

.mini-label {
  margin-top: 6px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
}

.p.small {
  font-size: 12.5px;
  margin-top: 6px;
}

/* Responsive */
@media (max-width: 520px) {
  .grid-2 {
    grid-template-columns: 1fr;
  }
  .grid-3 {
    grid-template-columns: 1fr;
  }
}
</style>
